import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=1b40c6d5&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b40c6d5')) {
      api.createRecord('1b40c6d5', component.options)
    } else {
      api.reload('1b40c6d5', component.options)
    }
    module.hot.accept("./mark.vue?vue&type=template&id=1b40c6d5&", function () {
      api.rerender('1b40c6d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/svg-media/mark.vue"
export default component.exports